import { Component, ElementRef, Input, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { Subject, Subscription } from 'rxjs';
import { ChatData } from '../../../@core/interfaces/portal/chatData';
import { ChatService } from '../chat.service';
import { EndConversationDialogComponent } from '../end-conversation-dialog/end-conversation-dialog.component';
import { debounceTime } from 'rxjs/operators';

@Component({
    selector: 'ngx-chat-popup',
    templateUrl: './chat-popup.component.html',
    styleUrls: ['./chat-popup.component.scss']
})
export class ChatPopupComponent implements OnInit, OnDestroy {

    isTyping = false;
    text !: string;

    @ViewChild('scroll') private scrollContainer: ElementRef;

    subscription: Subscription;
    private subject: Subject<string> = new Subject<string>();;

    get queueObject() {
        return this.chatService.queueObject;
    }

    get channelObject() {
        return this.chatService.channelObj;
    }

    get useQueueSplash() {
        return this.chatService.bUseQueueSplash;
    }

    get userName() {
        return this.chatService.userName;
    }

    get messages() {
        return this.chatService.messages;
    }

    get isTypingMessage() {
        return this.chatService.isTypingMessage;
    }

    get endByProvider(){
        return this.chatService.endByProvider;
    }

    constructor(private dialogService: NbDialogService, private chatService: ChatService) {
        console.log("Chat Popup");
        this.subscription = this.chatService.getMessageSubject().subscribe(() => this.scrollToBottom());
    }

    ngOnInit(): void {
        this.subject.pipe(debounceTime(1000)).subscribe(() => {
            this.chatService.doTyping(false).subscribe(() => {
                this.isTyping = false;
            })
        });
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
        this.subject?.unsubscribe();
    }

    doStartChat(event: any) {
        event.preventDefault();
        this.chatService.addQueue();
    }

    doCancelChat(event: any) {
        event.preventDefault();
        this.chatService.cancelQueue();
    }

    doSendMessage(event: any) {
        event.preventDefault();
        this.chatService.sendMessage(this.text);
        this.text = "";
    }

    scrollToBottom(): void {
        try {
            console.log("scroll");
            this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight + 50;
        } catch (err) { }
    }

    doClose(event: any) {
        event.preventDefault();
        this.chatService.bShowHideChatForm = !this.chatService.bShowHideChatForm;
        this.queueObject.end = false;
    }

    endConversation(event: any) {
        event.preventDefault();
        this.chatService.getUserInfo().then(user => {
            this.dialogService.open(EndConversationDialogComponent, {
                context: {
                    message: `Deseja encerrar a conversa com '${user.isProvider ? this.channelObject.buyerName : this.channelObject.providerName}?'`,
                }, closeOnBackdropClick: false
            })
                .onClose.subscribe(stausConfirm => {
                    if (stausConfirm === true) {
                        this.chatService.endConversation(this.channelObject.channelId, user.isProvider);
                    }
                });
        });
    }

    doKeyPress(event: any) {
        event.preventDefault();

        var regex = new RegExp("^[a-zA-Z0-9 ]+$");
        var str = String.fromCharCode(!event.charCode ? event.which : event.charCode);
        if (regex.test(str)) {
            if (!this.isTyping) {
                this.isTyping = true;
                this.chatService.doTyping(true).subscribe(() => {
                    this.subject.next(this.text);
                });
            }
        }        
    }
}
